export const HeroIllustrationImage = () => {
  return (
    <img
      src="/images/Hero_Illustration_Web_Optimized.jpg"
      className="h-[300px]"
      alt="Illustration Web-Optimized"
    />
  );
};
